import { miniCartUIAction } from "state/actions/types/ui/miniCartUIActionsTypes";

export interface MiniCartUIReducer {
  miniCartIsOpen: boolean;
}

const initialState: MiniCartUIReducer = {
  miniCartIsOpen: false
};

export default (
  state: MiniCartUIReducer = initialState,
  action: miniCartUIAction
): MiniCartUIReducer => {
  switch (action.type) {
    case "OPEN_MINI_CART":
      return {
        ...state,
        miniCartIsOpen: true
      };
    case "CLOSE_MINI_CART":
      return {
        ...state,
        miniCartIsOpen: false
      };
    default:
      return state;
  }
};
